import React from 'react'
import { Portal } from 'react-portal'
import actions from 'redux/actions'
import cx from 'classnames'
import { constants, links, mixpanel } from 'common/helpers'
import { useBodyOverlay, useCallback } from 'sb-hooks'
import { useConnect } from 'sb-redux-hook'

import Overlay from 'components/layout/Overlay/Overlay'
import CloseIcon from 'components/ui/CloseIcon/CloseIcon'
import { WidthContainer } from 'components/_new/layout/widthContainer'
import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'
import Link from 'components/_new/typography/Link/Link'
import Href from 'components/_new/ui/Href/Href'
import Button from 'components/_new/Button/Button'
import Image from 'components/_new/ui/Image/Image'

import instagramIcon from './images/instagram.svg'

import messages from './messages'
import s from './SidebarNav.scss'


const SidebarNav = () => {
  const { isOpened, isMixPage } = useConnect({
    isOpened: 'models.ui.isSideMenuVisible',
    isMixPage: (state) => state.routing.location.pathname === links.mix,
  })

  const nav = [
    { message: messages.fragrance, href: links.home },
    { message: messages.makeup, href: '/makeup-intro' },
    { message: messages.skincare, href: '/skincare-intro' },
    { message: messages.recommendations, to: links.quiz },
    { message: messages.aboutScentbird, to: links.team },
    { message: messages.help, href: links.faq },
  ]

  useBodyOverlay(isOpened)

  const close = useCallback(() => {
    actions.models.ui.closeSideMenu()
  }, [])

  const trackLinkClick = useCallback((link) => {
    if (isMixPage) {
      mixpanel.track(constants.analyticsEvents.mix.burgerMenuLinkClick, { link })
    }
  }, [ isMixPage ])

  const sideMenuClassName = cx(s.sideMenu, {
    [s.opened]: isOpened,
  })

  const buttonTitle = {
    ...messages.subscribeFor,
    values: {
      subscriptionPrice: `$${constants.price.defaultPrice}`,
    },
  }

  return (
    <Portal>
      <div>
        {
          isOpened && (
            <Overlay onClick={close} />
          )
        }
        <div className={sideMenuClassName}>
          <div className={s.content}>
            <div className={s.section}>
              <div className={s.header}>
                <CloseIcon className={s.closeIcon} whiteColor onClick={close} />
              </div>
              <WidthContainer>
                {
                  nav.filter((item) => item).map((item, index) => (
                    <Link
                      key={index}
                      color="white"
                      withUnderline={false}
                      onClick={() => trackLinkClick(item.to || item.href)}
                      to={item.to}
                      href={item.href}
                    >
                      <Box pt="12" pb="12">
                        <Text size="18-24" message={item.message} />
                      </Box>
                    </Link>
                  ))
                }
                <Box pt="24">
                  <Box mb="12">
                    <Button
                      color="brand"
                      title={buttonTitle}
                      to={links.register}
                      onClick={() => trackLinkClick(links.register)}
                      fullWidth
                      size="md"
                    />
                  </Box>
                  <Box mb="12">
                    <Button
                      color="white"
                      title={messages.logIn}
                      to={links.login}
                      onClick={() => trackLinkClick(links.login)}
                      fullWidth
                      size="md"
                    />
                  </Box>
                  <Box mb="12">
                    <Href className={s.instagram} toTab="https://instagram.com/scentbird/">
                      <Image src={instagramIcon} />
                      <Text className={s.join} message={messages.join} html />
                    </Href>
                  </Box>
                </Box>
              </WidthContainer>
            </div>
          </div>
        </div>
      </div>
    </Portal>
  )
}


export default SidebarNav
